import useDriftAccountStore from 'src/stores/useDriftAccountsStore';

export const useAccountFetchedAndExists = () => {
	const accountExists = useDriftAccountStore(
		(s) => Object.keys(s.accounts).length > 0
	);
	const hasLoadedAccounts = useDriftAccountStore((s) => s.hasLoadedAccounts);

	return [hasLoadedAccounts, accountExists];
};
